import React from 'react';
import { useDispatch } from 'react-redux';
import { ButtonStyled, TextStyled } from '@nike/nike-design-system-components';
import { func, bool, object } from 'prop-types';
import { Box, Flex } from 'rebass';

import Modal from '../../modal/Modal';

import { updateDepartmentCatalogTypes } from './actions';

const RemoveCatalogTypeModal = ({
  isOpen,
  closeModal,
  department,
  selectedCatalogType,
  bulkSetDepartmentCatalogTypes
  // refreshTableData
}) => {
  const dispatch = useDispatch();

  const handleRemoveCatalogTypeFromDepartment = async ({ catalogTypeToRemove }) => {
    const updatedCatalogTypes = department.catalogTypes.filter(ct => ct.id !== catalogTypeToRemove.id);
    const updatedCatalogTypeIds = updatedCatalogTypes.map(catalogType => ({ id: catalogType.id }));

    await dispatch(updateDepartmentCatalogTypes({ departmentId: department.id, catalogTypes: updatedCatalogTypeIds }));
    bulkSetDepartmentCatalogTypes({ [department.id]: updatedCatalogTypes });
    // refreshTableData();
  };

  const content = () => {
    return (
      <Box width='100%'>
        <TextStyled appearance='title4'>
          {`Are you sure you want to remove ${selectedCatalogType?.name} from ${department.name}?`}
        </TextStyled>
      </Box>
    );
  };

  const footer = ({ toggleIsLoading }) => {
    const handleSubmit = async () => {
      toggleIsLoading(true, 'Removing Catalog Type...');

      await handleRemoveCatalogTypeFromDepartment({
        catalogTypeToRemove: selectedCatalogType
      });

      toggleIsLoading(false);

      closeModal();
    };

    return (
      <Flex>
        <ButtonStyled
          data-testid='remove-catalog-type-cancel-button'
          type='button'
          appearance='secondary'
          background='light'
          size='small'
          onClick={closeModal}
          style={{ marginRight: '15px' }}
        >
          Cancel
        </ButtonStyled>

        <ButtonStyled
          data-testid='remove-catalog-type-submit-button'
          type='button'
          appearance='primary'
          background='light'
          size='small'
          onClick={handleSubmit}
        >
          Remove
        </ButtonStyled>
      </Flex>
    );
  };

  return (
    <Modal title='Remove Catalog Type' content={content} footer={footer} isOpen={isOpen} closeModal={closeModal} />
  );
};

RemoveCatalogTypeModal.propTypes = {
  closeModal: func.isRequired,
  isOpen: bool,
  department: object,
  selectedCatalogType: object.isRequired,
  bulkSetDepartmentCatalogTypes: func.isRequired
  // refreshTableData: func.isRequired
};

RemoveCatalogTypeModal.defaultProps = {
  isOpen: false,
  department: {}
};

export default RemoveCatalogTypeModal;
